export default "__VITE_ASSET__BsexQ7rR__"